import React from 'react';
import { Button } from './ui/button';
import { useLang } from '../i18n/LanguageContext';

export const Resume = () => {
  const { t } = useLang();

  return (
    <section id="resume" className="py-8 lg:py-12">
      <div className="section-container">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {t.resume.title}
          </h2>

          <p className="text-lg text-muted-foreground leading-relaxed">{t.resume.intro}</p>

          <div className="pt-6">
            <Button
              size="lg"
              className="bg-foreground hover:bg-foreground/90 text-background font-medium px-8 py-6 text-base rounded-sm transition-all hover:shadow-lg group"
              onClick={() => window.open('/CV_RDLF_ESP_2026.pdf', '_blank')}
              data-testid="cv-download-btn"
            >
              <svg className="mr-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              {t.resume.download}
            </Button>
          </div>

          <div className="pt-8 text-sm text-muted-foreground">
            <p>
              {t.resume.linkedInPre}{' '}
              <a
                href="https://www.linkedin.com/in/ra%C3%BAl-de-la-fuente-p%C3%A9rez-puelles-21703630/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent hover:underline"
              >
                LinkedIn
              </a>
              {t.resume.linkedInPost}
            </p>
          </div>
        </div>
      </div>

      <div className="section-divider" />
    </section>
  );
};
